'use client';

import {usePathname} from 'next/navigation';
import {useEffect, useContext} from 'react';

import Analytics from '@/lib/analytics';
import {SettingContext} from '@/context/Setting';

/** Initializes the Google Analytics global tag. */
export function useInitializeAnalytics() {
  const [{cookieConsent: consent}] = useContext(SettingContext)!;

  useEffect(() => {
    const analytics = new Analytics();
    if (!analytics.initialized) {
      analytics.initialize(consent.googleAnalytics);

      // Sending event for unhandled exceptions
      window.onunhandledrejection = event =>
        analytics.exceptionEvent(
          Analytics.serializeErrorMessage(
            'Uncaught (in promise)',
            event.reason
          ),
          false
        );
      window.onerror = (event, source, line, column, error) => {
        analytics.exceptionEvent(
          Analytics.serializeErrorMessage(
            typeof event === 'string' ? event : event.type,
            error
          ),
          true
        );
        return false;
      };
    }
    analytics.manageConsent(consent.googleAnalytics);
  }, [consent]);

  return null;
}

/** Sends the Google Analytics page view event on navigation change. */
export function useSendPageView() {
  const pathname = usePathname();

  // Sending `page_view` event
  useEffect(() => {
    new Analytics().pageViewEvent(
      window.document.title,
      `${window.location.origin}${pathname}`
    );
  }, [pathname]);

  return null;
}
